import { ADDRESS, BANK, DOB, GUARDIAN, NOMINEE, PINCODE } from '../../../../redux-store/types/nct';
import { Categories, FundSizes, Risks } from '../../../../redux-store/types/newPurchase';
import { IsAllow, PlanTypes } from '../../../../redux-store/types/portfolio';
import { NOMINEEINFO } from '../../makeNct/UpdateNominee/update-nominee-edit';

export type MFFilterBoxProps = {
    image: string;
    fund: any;
    history: any;
    isinCode: string;
    profit?: number;
    year: ReturnsTimeLines | string | number;
};

export type FundFiltersTypes<T> = {
    amcs: T[];
    categories: T[];
    fundSizes: T[];
    risk: T[];
    planMode: T[];
    minimumInvestment: T[];
};
export enum FilterKeys {
    Amc = 'amcs',
    Categories = 'categories',
    FundSizes = 'fundSizes',
    Risk = 'risk',
    PlanMode = 'planMode',
    MinimunInvestment = 'minimumInvestment',
}

export type Id = Categories | FundSizes | Risks | string | PlanTypes | MinimunInvestMentTypes;
export type Filter = { name: string; value: Id; sub?: Filter[] };

export type Bank_New = Pick<
    BANK,
    | 'accountNo'
    | 'accountType'
    | 'branch'
    | 'ifsc'
    | 'city'
    | 'neftIfsc'
    | 'name'
    | 'micr'
    | 'pincode'
> & { bankDefault: IsAllow };
export type NewPurchasePayload = {
    amc: Id;
    images?: Array<any>;
    schemeOptions: SchemeOptionType[];
    investorDetails: {
        bank: Bank_New;
        nominee: Nominee[];
        fatcaDetails: FatcaDetails[];
        nomineeFlag?: boolean;
        title: string;
        investorName: string;
        gender: string;
        validPan: IsAllow;
        dob: string;
        email: string;
        eNomMobileStatus: string;
        nomineeInSoa: string;
        mobile: string;
        address: ADDRESS[] | undefined;
        eNomType: string;
        eNomDocId: string;
        eSignFlag: string;
        noNominee: string;
        emailRelationship: string;
        mobileRelationship: string;
        otpSentTo: string;
        dpid: string;
        source: string;
        countryCode: string;
        taxStatus: string;
        ckycNo: string;
        kycStatus: string;
        occupation: string;
        pep: string;
        invNameValid?: 'Y' | 'N';
        invDobValid?: 'Y' | 'N';
        panRemarks?: string;
        holdingMode: string;
        grossAnnualIncome: string;
        nriDeclarationFlag: string;
    };
    instNo: string;
    omUMRN: string;
    mandateRefId: string;
    payInMode: string;
    payInRefno: string;
    payInBankName: string;
    payInBankAcno: string;
    tpvFlag: IsAllow;
};

export type FatcaDetails = {
    fatcaId: string;
    placeOfBirth: string;
    addressType: string;
    countryOfBirth: string;
    taxResidencyOtherthanIndia: IsAllow;
    countryCitizen: string;
    taxResidency: TaxDetails[];
    annualIncomeSlab: string;
    occupation: string;
    pepFlag: IsAllow;
    netWorth: string;
    netWorthDate: string;
    sourceOfWealth: string;
    sourceOfFunds: string;
    fatherName: string;
    spouseName: string;
    corporateServices: string;
    declaration?: IsAllow;
    nationality?: string;
};

export type TaxDetails = {
    id: Id;
    countryTax: string;
    taxId: string;
    type: string;
    tinReason: string;
};

export enum ReInvestTypes {
    Payout = 'N',
    ReInvestment = 'Y',
    Growth = 'Z',
}

export enum PaymentTypes {
    Lumpsum = 'Lumpsum',
    SIP = 'SIP',
}
export type SchemeOptionType = {
    itemNo: string;
    isin: string;
    reInvest: ReInvestTypes;
    amount: string;
    trxnType: string;
    trxnDate: string;
    trxnTime: string;
    userTrxnNo: string;
    distId: string;
    subDist: string;
    subBrokerARN: string;
    euin: string;
    euinDeclarationFlag: string;
    riaCode: string;
    startDate: string;
    endDate: string;
    registrationDate: string;
    registrationAmount: string;
    frequency: string;
    noOfInstallments: string;
    sipType: string;
    minSipTat: string;
    maxSipTat: string;
    folio: string;
    investorName: string;
    email: string;
};

export type Nominee = {
    dob: DOB;
    gender: string;
    address1: string;
    address2?: string;
    address3?: string;
    addressSameAsFH: string;
    pan?: string;
    country: string;
    state: string;
    city?: string;
    pincode: PINCODE;
    id: string;
    name: string;
    percentage: number;
    relation: string;
    nomineeGuardian?: GUARDIAN;
    email?: string;
    mobile?: string;
    docName?: string;
    docValue?: string;
};

export enum ExplorePaths {
    NewPurchase = '/purchase',
    Explore = '/explore',
    SchemeDetails = '/:isin/explore',
    Invest = '/:isin/invest',
    PaymentMethod = '/:userTrxnNo/:reqId/payment',
    ProfileDetails = '/:isin/edit',
    OtpVerify = '/verify-otp',
    EditNominee = '/:isin/edit/nominee',
    EditBank = '/:isin/edit/bank',
    EditFatca = '/:isin/edit/fatca',
    PaymentStatus = '/payment-status/:id',
    ProspectPaymentStatus = '/prospect-payment-status/:id',
    OTMPaymentStatus = '/otm-payment-status/:reqId',
}

export type ArnPayloadType = Pick<
    SchemeOptionType,
    'distId' | 'subDist' | 'subBrokerARN' | 'euin' | 'euinDeclarationFlag' | 'riaCode'
> & { planCode: PlanTypes; amc: string | number };

export enum ErrorSectionTypes {
    PersonalDetails,
    NomineeDetails,
    FatcaDetails,
    KycDetails,
    BankDetails,
}

type ChangeType<T, V> = { [K in keyof T]: V };
type ErrorType = Partial<ChangeType<NewPurchasePayload, string>>;

export type ValidationErrorRes = {
    error: boolean;
    message?: string;
    section?: ErrorSectionTypes;
    errorField?: ErrorType;
    index?: number; // For multiple boxes
};

export enum folioPurchaseEnum {
    NEW = 'new',
    EXISTING = 'existing',
}

export const explorePath = '/portal/commercial/explore';

export enum Trxntypes {
    AP_LUMPSUM = 'AP',
    FP_LUMPSUM = 'FP',
    AP_SIP = 'ASIP',
    FP_SIP = 'FSIP',
}

export enum MinimunInvestMentTypes {
    LESS_THAN_FIVE_HUNDRED,
    FIVE_HUNDRED_TO_TWO_THOUSAND,
    GREATER_THAN_TWO_THOUSAND,
}

export enum ReturnsTimeLines {
    One_Month = '1M',
    Three_Months = '3M',
    Six_Months = '6M',
    One_Year = '1Y',
    Three_Years = '3Y',
    Five_Years = '5Y',
    All = 'ALL',
}

export type ReturnsData = {
    label: string;
    shortLabel?: string;
    value: ReturnsTimeLines;
};

export const ReturnPeriods: ReturnsData[] = [
    {
        label: '1 Month',
        shortLabel: '1M',
        value: ReturnsTimeLines.One_Month,
    },
    {
        label: '3 Months',
        shortLabel: '3M',
        value: ReturnsTimeLines.Three_Months,
    },
    {
        label: '6 Months',
        shortLabel: '6M',
        value: ReturnsTimeLines.Six_Months,
    },
    {
        label: '1 Year',
        shortLabel: '1Y',
        value: ReturnsTimeLines.One_Year,
    },
    {
        label: '3 Year',
        shortLabel: '3Y',
        value: ReturnsTimeLines.Three_Years,
    },
    {
        label: '5 Year',
        shortLabel: '5Y',
        value: ReturnsTimeLines.Five_Years,
    },
    {
        label: 'All',
        shortLabel: 'All',
        value: ReturnsTimeLines.All,
    },
];

export enum OTMVerifyStatus {
    NOT_SET = 'Not Set',
    VALID = 'Valid',
    NOT_VALID = 'Not Valid',
}
